import { render, staticRenderFns } from "./TaskDeleteTooltip.vue?vue&type=template&id=c60ecf58&scoped=true&"
import script from "./TaskDeleteTooltip.vue?vue&type=script&setup=true&lang=ts&"
export * from "./TaskDeleteTooltip.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./TaskDeleteTooltip.vue?vue&type=style&index=0&id=c60ecf58&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c60ecf58",
  null
  
)

export default component.exports